import React from 'react';
import Survey from 'src/components/survey/survey';
import Modal from 'src/modules/shared/modal/components/modal';
import ChooseUsernameForm from './chooseUsernameForm';
import TermsModal from './termsModal';
import SorryToSeeYouGoModal from './sorryToSeeYouGoModal';
import i18n from 'i18next';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

class SignupSurvey extends React.Component {
  static defaultProps = {
    options: [],
    value: [],
    onSave: () => {},
  };

  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      currentPosition: 0,
      username: null,
      acceptResearch: null,
      currentModalName: 'default',
      isSubmitting: false,
    };
  }

  onShowTermsClick = e => {
    e.preventDefault();
    this.setState({ currentModalName: 'terms' });
  };

  onRefuse = e => {
    e.preventDefault();
    this.setState({ currentModalName: 'sorry' });
    trackFootfallEvent(footfallEventTypes.CLICKED, {
      clickType: 'join-not-agree',
    });
  }

  getScreens = () => {
    return [
      {
        id: 1,
        key: 'username',
        title: i18n.t('Create a username'),
        content: (
          <div>
            <p>{i18n.t('Choose an anonymous username to safely share your experiences.')}</p>
            <p>{i18n.t('You can change this later.')}</p>
            <div>
              <ChooseUsernameForm
                onUsernameChange={username => {
                  this.setState({ username });
                }}
              />
            </div>
            <div className="signup-box__tips">
              {i18n.t('Tips for an anonymous username:')}
              <ul>
                <li>{i18n.t("Don't use parts of your name, address or phone number")}</li>
                <li>{i18n.t("Don't use the same username you have elsewhere")}</li>
                <li>{i18n.t('Consider your favorite hobby, animal, music, movie, color, etc')}</li>
              </ul>
            </div>
          </div>
        ),
      },
      {
        id: 2,
        key: 'acceptTerms',
        title: i18n.t('Our Terms'),
        content: (
          <div>
            <p>
              {i18n.t('We want you to understand how our service works. Please review and accept')}{' '}
              <a href="#" onClick={this.onShowTermsClick}>
                {i18n.t('our terms')}
              </a>{' '}
              {i18n.t('to join HealthUnlocked.')}
            </p>
            <div className="signup-box__tips">
              <div className="signup-box__highlights">{i18n.t('The highlights')}</div>
              <ul>
                <li>{i18n.t('You must be 16 or older to create an account.')}</li>
                <li>{i18n.t('You must not use the site as subsitute for professional medical advice.')}</li>
                <li>
                  {i18n.t('You are encouraged to use an anonymous username and never reveal your identity to others.')}
                </li>
                <li>{i18n.t('You must not use the site for commercial purposes.')}</li>
                <li>
                  {i18n.t(
                    'Your contributions must comply with applicable law in any country from which they are posted.',
                  )}
                </li>
                <li>
                  {i18n.t('Your are entirely responsible for any and all activities that occur under your account.')}
                </li>
                <li>{i18n.t('You will receive information about your account (whether by email or on the site).')}</li>
              </ul>
              <div className="signup-box__tips__footer" >
                <a href="#" onClick={this.onShowTermsClick}>
                  {i18n.t('Read our full Terms')}
                </a>
              </div>
            </div>
            <p>{i18n.t('You must accept our Terms to create an account on HealthUnlocked')}</p>
            <p>
              <a href="#" onClick={this.onRefuse}>{i18n.t('I do not accept.')}</a>
            </p>
          </div>
        ),
        buttonText: i18n.t('I accept'),
      },
    ];
  };

  getSurveyProgress = () => {
    const progressValues = [50, this.state.currentPosition >= 1 ? 25 : 0, this.state.currentPosition >= 2 ? 15 : 0];
    return progressValues.reduce((a, b) => a + b, 0);
  };

  isValidScreen = () => {
    if (this.state.isSubmitting) {
      return false;
    }
    const screens = [...this.getScreens()];
    const currentScreen = screens[this.state.currentPosition];
    switch (currentScreen.key) {
      case 'username':
        return !!this.state.username;
      default:
        return true;
    }
  };

  onPositionChanged = (position) => {
    const screens = this.getScreens();
    const currentScreen = screens[this.state.currentPosition];
    switch (currentScreen.key) {
      case 'username':
        trackFootfallEvent(footfallEventTypes.CLICKED, {
          clickType: 'join-username-entered',
        });
        break;
      case 'acceptTerms':
        trackFootfallEvent(footfallEventTypes.CLICKED, {
          clickType: 'join-agreed',
        });
        break;
    }
    this.setState({ currentPosition: position });
  }

  renderScreen = (screen, i) => {
    return (
      <div
        className="survey__screen survey__screen--no-header signup-box__questions"
        key={i}
      >
        <h3 className="signup-box__questions__title">{screen.title}</h3>
        {screen.content}
      </div>
    );
  };

  render() {
    const screens = [...this.getScreens()];

    return (
      <React.Fragment>
        <Modal
          dialogClasses={{
            'app-modal--hidden': this.state.currentModalName !== 'default',
          }}
          noClose={true}
        >
          <Survey
            className="signup-box__survey"
            hideHeader={true}
            isNextButtonDisabled={!this.isValidScreen()}
            progress={this.getSurveyProgress()}
            renderScreen={this.renderScreen}
            screens={screens}
            onFinish={() => {
              const { username } = this.state;
              this.setState({ isSubmitting: true });
              this.props.onFinish({ username });
            }}
            onPositionChanged={this.onPositionChanged}
          />
        </Modal>
        {this.state.currentModalName === 'terms' && (
          <TermsModal
            isOpen={this.state.currentModalName === 'terms'}
            onClose={() => this.setState({ currentModalName: 'default' })}
          />
        )}
        {this.state.currentModalName === 'sorry' && (
          <SorryToSeeYouGoModal
            onCancel={() => this.props.closeModal()}
            onClose={() => this.setState({ currentModalName: 'default' })}
          />
        )}
      </React.Fragment>
    );
  }
}

export default SignupSurvey;



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/signupSurvey.js